/**
 * Polskie etykiety dla tego, co Postmark zwraca po angielsku (TRE-1715).
 *
 * Klucze tagów to aliasy szablonów — źródłem prawdy jest
 * `packages/email-templates/TEMPLATES.md` (i `EMAIL_TEMPLATE` w services-shared).
 * Nieznany alias pokazujemy surowy zamiast chować: lepiej, żeby trener zobaczył
 * `jakis-nowy-szablon` niż puste pole po dodaniu maila, o którym ta lista nie wie.
 */

export const emailStatusLabels: Record<string, string> = {
  Sent: "Wysłany",
  Processed: "Przetworzony",
  Queued: "W kolejce",
  Bounced: "Odbity",
  Failed: "Niedostarczony",
};

export const emailStatusColors: Record<string, string> = {
  Sent: "green",
  Processed: "blue",
  Queued: "gold",
  Bounced: "red",
  Failed: "red",
};

/** Zdarzenia z osi czasu w podglądzie maila (`MessageEvents` z Postmarka). */
export const emailEventLabels: Record<string, string> = {
  Delivered: "Dostarczony",
  Opened: "Otwarty",
  LinkClicked: "Kliknięto link",
  Bounced: "Odbity",
  SpamComplaint: "Zgłoszony jako spam",
  Transient: "Chwilowy problem z dostarczeniem",
  SubscriptionChanged: "Zmiana subskrypcji",
};

export const emailEventColors: Record<string, string> = {
  Delivered: "green",
  Opened: "blue",
  LinkClicked: "cyan",
  Bounced: "red",
  SpamComplaint: "red",
  Transient: "orange",
  SubscriptionChanged: "default",
};

export const emailTemplateLabels: Record<string, string> = {
  // do klientki
  "client-app-access": "Dostęp do aplikacji",
  "client-app-access-otp": "Dostęp do aplikacji (kod)",
  "client-app-access-starter": "Dostęp do aplikacji (Zestaw Startowy)",
  "client-app-access-reminder-otp": "Przypomnienie o dostępie (kod)",
  "client-free-subscription-notification": "Darmowy dostęp",
  "client-login-by-link": "Logowanie linkiem",
  "client-data-breach-fakturownia": "Informacja o wycieku danych z Fakturowni",
  "client-new-nutrition-program": "Nowy plan żywieniowy",
  "client-new-survey": "Nowa ankieta",
  "client-new-survey-added": "Dodano ankietę",
  "client-new-workout-program": "Nowy plan treningowy",
  "client-payoff-offer": "Oferta dopłaty do całości rat",
  "client-payoff-offer-reminder": "Przypomnienie o ofercie dopłaty",
  // windykacja rat (TRE-2169)
  "client-collections-card-failed": "Windykacja K1: nie udało się pobrać raty",
  "client-collections-card-reminder": "Windykacja K2: nadal nie udało się pobrać",
  "client-collections-card-exhausted": "Windykacja K3: ponowienia wyczerpane",
  "client-collections-transfer-upcoming": "Windykacja M1: przypomnienie przed terminem",
  "client-collections-transfer-overdue": "Windykacja M2: termin minął",
  "client-collections-transfer-week-overdue": "Windykacja M3: tydzień po terminie",
  "client-collections-demand": "Windykacja W1: wezwanie do zapłaty",
  "client-collections-final-demand": "Windykacja W2: ostateczne wezwanie",
  "client-collections-installment-added": "Windykacja: nowa rata dołączyła do zaległości",
  "client-collections-paid": "Windykacja: rata rozliczona",
  "client-product-access-prolonged": "Przedłużony dostęp",
  "client-product-manual-renewal": "Odnowienie — płatność ręczna",
  "client-product-manual-renewal-failed-blik": "Nieudane odnowienie BLIK",
  "client-product-payment-failed-card": "Nieudane pobranie z karty",
  "client-product-order-confirmation": "Potwierdzenie zamówienia",
  "client-product-purchase-notification": "Potwierdzenie zakupu",
  "client-product-purchase-notification-addon": "Potwierdzenie zakupu — dodatek",
  "client-product-purchase-notification-content": "Potwierdzenie zakupu — treści",
  "client-product-purchase-notification-event": "Potwierdzenie zakupu - wydarzenie",
  "client-unread-messages": "Nieprzeczytane wiadomości",
  "email-changed": "Zmiana adresu e-mail",
  "password-reset": "Reset hasła",

  // do zespołu — w skrzynce klientki nie wystąpią, ale trafiają na tę samą listę
  // w Postmarku, więc niech mają nazwę zamiast surowego aliasu
  "invitation-to-team": "Zaproszenie do zespołu",
  "issue-with-invoice": "Błąd wystawienia faktury",
  "owner-email-system-error": "Błąd systemu mailowego",
  "owner-failed-payment": "Nieudana płatność",
  "owner-free-subscription-notification": "Darmowy dostęp (powiadomienie)",
  "owner-product-access-prolonged": "Przedłużony dostęp (powiadomienie)",
  "owner-product-access-prolonged-prepaid": "Przedłużony dostęp — przedpłata",
  "owner-product-purchase-notification": "Nowy zakup (powiadomienie)",
  "owner-product-purchased-manual-payment": "Zakup — płatność ręczna",
  "owner-product-renewal-manual-payment": "Odnowienie — płatność ręczna",
  "owner-product-renewal-notification": "Odnowienie dostępu",
  "trainer-login-by-link": "Logowanie linkiem (trener)",
  "trainer-survey-answers": "Odpowiedzi z ankiety",
  "trainer-unread-messages": "Nieprzeczytane wiadomości (trener)",
};
